<template>
  <div class="zoom-stars-map native-pinch zoom-page">
    <div class="top-tool-nav-wrap">
      <a @click="$router.go(-1)" class="btn-close-circle" aria-hidden="true"><span class="visuallyhidden">close Zoom View</span></a>
    </div>
    <div class="zoomed-img-wrap">
      <div class="plates-wrap " :style="'margin-top:' + workPosLive + 'px'">
        <div class="plate-bg scale-item" :style="'height:'+ plateWidthLive +'px; width:'+ plateWidthLive +'px'">
          <svg version="1.1" class="plate-bg__img" preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 2168 2835" xml:space="preserve">
              <defs>
                  <clipPath id="clip_plate-bg">
                    <path fill-rule="evenodd" d="m1509 687 605 609 1 869-601 618-859 11S85.44 2217.2 51 2170c0 0-.83-865.41-2-871 0 0 424.25-460.29 592-620z"/>
                    <path fill-rule="evenodd" d="M675 683s-36.74-28.76-12-55c15.84-16.81 34-1 34-1s7.28-2.29 12 4 25 23 25 23l29-1s56.68-23.4 72-36c0 0 22.93-10.23 44 1 0 0 23-41.41 47-63 0 0 9.41-17.45 32-24 0 0 19.77-15.33 82-27 0 0-12.07-9-11-21s8.55-20.65 15-23v-2s-18.47-3.36-18-34c0 0 5-33.35 31-36 0 0-3.68-5.08 3-6v-23h-26s-7 .53-7-4v-1h-2v-8h-5s.41.93-7 1l-4-1h-3a11.17 11.17 0 0 1-3-8 10.58 10.58 0 0 1 4-8s11.76-8.91 19-9 4 0 4 0a8.56 8.56 0 0 1-2-5c0-2.93 3-5 3-5l6-4h1v-1h-1l-4-4s-4-5.57-4-9-.18-8.05 2-8v-4s2.67-5.4 12-13c0 0 1-.25 1-2v-15s-5.62-.69-1-7v-2s-13.08-23.19-29-32c0 0-4-.51-1 4s5 8 5 8a3.14 3.14 0 0 1 1 2v10s-1.17 0-1 3-.32 4.66 1 5v8l-6 7s-4.93 1.23-5 3 .8 4-3 7c0 0-.12 17.61-3 24-2.6 5.77-7.82 13.28-14 17-6.58 4-14.17 8.31-20 10-4.44 1.29-14.48 4.68-25 1s-21.32-10.32-32-23c0 0-7-7.7-8-32 0 0-.25-26.35 10-41s19.52-27 35-34c0 0 14.38-6.59 41-6 0 0 18.55-.47 28 9 0 0 5.25 2.54 1-2s-9.68-8.07-12-15-4.08-13.17-4-17 1-18.78 6-25c0 0 1-1.93-4-2-4-.05-3.93.14-4-2h-10s-3.22 8.94-12 9c0 0-3 .15-3-2s-4-2.46-4 0c0 0-.67 4-9 4 0 0-8.28.75-11-6-1.73-4.31-3 0-3 0a6.82 6.82 0 0 1-7 5h-9s-1.79.66-5-7c-1-2.35-1.69-.42-2 0s-2.64 6-9 6-9-4-9-4 .94 7-6 8c0 0-4.81 18.36-10 23-5.51 4.92-6.21 6.91-18 10 0 0-8.51.89-10 0s-5.09-3-5-8-2-5-2 0a8.24 8.24 0 0 1-8 6h-8s-4.11-2.64-4 1 1.31 6.69-2 9c0 0-.36 1.86 1 2 0 0 5.32 3.25 1 6a1.3 1.3 0 0 0 1 2s6.23 3.62 6 10a6.49 6.49 0 0 1-3 7c-4.17 2.57-1.93 6.1-2 7-.24 3.1-4 6-4 6s-8.61 8-13 8h-23s-6.17.48-7-2c0 0 .75-1-7-1 0 0-3.57.34-11-10 0 0-6.88-7.45-7 2 0 0 0 4.07 1 4v5l-7 5s-1.89 7.73-8 7-13.58-1.41-14-6-.65-8.2 0-9a10.1 10.1 0 0 1 7-3c3.75-.1 7 .8 8 2s1 3 3 3 4.21.18 5-1h2v-12s1.91-1.06 0-2v-2h-2s-2.51-4.6 0-7 2.81-2.48 1-4v-8s3.8-4.09 8-4 1.83-1 1-1-9-19.29-6-25c2-3.85 0-3.56 0-4-.16-3.9 2.81-9 7-15s10-13 10-13v-2h-3v-1h2s-2-13 12-15a3.36 3.36 0 0 1 3 3h1v-3l11-9s3.41-.44 1-2v-3l5-4a2.21 2.21 0 0 0 1-2 2.21 2.21 0 0 1 1-2v-5s-7.06-5.93-10 0h-2v-2h1v-7s2-2.07 2-3-.34-3 1-3h10v-3h3v-1h1s1.48-4-2-4-7.88-.06-8 3h-2v-3s.58-4.06 7-4 7 0 7 0h3s1.26.26 4-2a8.33 8.33 0 0 1 4-1c2.36 0 2-3 2-3s1.57-4.9 27-6h4a54.79 54.79 0 0 1 11-11c6.74-5 16.16-3.72 17-3s7 2 7 2 9.17-5.56 20-5c0 0 6.91-3 20-3s15.25.19 20 3c0 0-.18-1 3-1h6a4.83 4.83 0 0 1 3 2 2.59 2.59 0 0 0 3 1s.57-.21 3 1a12.52 12.52 0 0 1 5 5c.61 1.28.79 3.69-1 4s-1 1-1 1h2v1h1v5a2 2 0 0 1-2 2h-1v2h9s7.26-8.27-1-14c0 0-5.1-2.84 0-3s10.91 3.82 9 12a12.12 12.12 0 0 1-6 8s-15.28.54-20-4c-2.31-2.23-7 7-7 7s-12.85 4-1 3c0 0 6.77-1 8 6 0 0-.1 3.08 2 3s10.56-1 11 4h11s3.77-3.18 6 1h5v6s13.16-14.15 37-11 18.16 6.35 30 4c0 0 9.59-3.6 13-1 0 0 4.26 2.72 1 12 0 0-5.2 5.51-8 8s-3.57 4-2 4 5-2 5-2 6.65-1.85 10 0a49.81 49.81 0 0 1 7 5l10 8a90.37 90.37 0 0 1 9 10c3.85 5.15 7.94 15.31 8 15s.16 4.32-5 3c-3.15-.81-3 1-3 1s4.59 27.49-16 51v4s23.63-16 36-16 49 1 49 1 17.29 4 29 13 20.54 16.09 26 29 11.12 22.35 5 42-14 27-14 27-11.47 22.34-47 22-40.18-15.95-42-18-6.32-12.32-6-22 0-12.23 1-18c0 0-21.86-26.13-8-46 0 0 2.37-3.74-3-1s-27.08 14.29-31 22c0 0 1.36 9-6 10 0 0-4.3 4.06-3 5s6 4 6 4v4h-2s14 27.94 15 33 6.51 23.5-2 28c0 0-2.68 2.71 2 3 0 0 13.72 8.51 17 10s8.68 11.65 2 13-10 2.54-10 7c0 0-2.9 2-10 2 0 0-3.34 9.07-7 10s-17 1-17 1-4.76.17-5 2 .45 3.06-2 3v2h2s5.39 11.61 6 18l1 5s21 .58 26 30l5 13a19.45 19.45 0 0 1-5 20c-7 7.15-13 6-13 6v3s10.61 9 12 13 .25 19.17-3 23a120.3 120.3 0 0 1-9 9v1s34.81 3.3 57 13 23 11 23 11 21.17-6.48 29 13c0 0 44 17.94 56 62 0 0 4.12.46 5 9 .46 4.46 3 0 3 0s2.73-3.46 4-3a7.45 7.45 0 0 1 0-3c.37-1.21 4.94-5 6-5s4.42.56 5 0 4.21-3.67 7-4 6.17-1.1 9 0 10.22 4.94 12 6 4.42 3.77 7 6 12 11.76 13 13 8.43 8.49 10 10a65 65 0 0 0 6 4s4.34 4.51 6 5 3.43.31 6 2 5.41 3 8 5a25.31 25.31 0 0 0 8 4c2 .52 6.12 3.74 8 4a3.12 3.12 0 0 1 3 3c.26 1.78 6 0 6 0s4.59 1 7-1 3.25-1.55 5-2 5 1 6-7 16.08-10.29 17-11 2.15-1.27 2-5 4-5 4-5a11.23 11.23 0 0 0 3-5c.94-3.22 4.67-4 11-3 3.81.57 5-1 5-1a18.71 18.71 0 0 1 13 1c7.25 3.13 14.71 5.06 19 21s1.45 22.62 1 26c0 0-6.74 7.58-9 9v6h11s7.13-.36 3 4z"/>
                    </clipPath>
                </defs>
            <image clip-path="url(#clip_plate-bg)" xlink:href="/assets/img/stars-map/bg-plate-zoom.jpg" width="2168" height="2835" />
          </svg>
        </div>
        <div class="plate-wrap scale-item">
          <div class="plate" id="rotator" :style="'height:'+ plateWidthLive +'px; width:'+ plateWidthLive +'px'">
            <svg  class="plate__img" preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 2168 2168" xml:space="preserve">
                <defs>
                    <clipPath id="clip_plate_zoom">
                     <path  d="M1001.61,2049.27c-14.87-1.67-30.83-1.39-46-5-12.29-2.92-26-2.64-39-6-36.06-9.33-72.9-13.65-107-25-32.32-10.74-65.39-20.74-96-34-13.81-6-28.53-14-42-20-17.35-7.69-34.15-14.38-50-24-19.43-11.79-40-22.44-59-35-10.56-7-24-19.23-34-23-6.66-2.5-11.59,3.59-15,5-7.61,3.17-14.92.41-24,3-7.1,2-9.75,7.44-19,8-6.42-6.35-17.47-8.83-23-16,5.74-4.42,26.82-32.69,27-42-18.2-10.67-30.64-28.64-47-41-10.21-7.71-18.07-17.07-27-26s-18.29-16.79-26-27l-10-9c-14.39-19-31.92-35.83-46-55-12.86-17.5-26-35-38-53-3.57-5.35-9.95-20.32-16-22l-40,33c-1.75-.63-1-.19-2-1-8.32-3.39-5.93-14.91-8-25-3.4-16.53,1.32-42.52,6-56,2.2-6.35,6.36-10.41,7-19-8.4-9.49-12.63-24.85-18-37-6-13.47-14-28.19-20-42-6.11-14.06-9.05-27.53-15-42-9.88-24-15.37-49.43-24-76-10.34-31.82-14.55-68.31-23-103-3.72-15.27-2.65-31.33-6-46-3.74-16.36-.44-34.18-4-50v-23c-2.93-13.62-3-48.4,0-62v-23c2.76-12.27,1.31-28.1,4-40l1-19c5-21.45,5.63-45.61,11-66,3.91-14.86,3.85-28.46,8-43,14.79-51.8,27.8-102.48,48-149,86.2-198.52,217.53-346.88,392-457,48-30.28,102-54.27,157-77l53-18c2-4.36,1.76-11.51,4-17,2.53-6.18,8.9-10.41,11-17,1.24-3.88-.79-8.1,1-11,5.48-8.86,18.34-11.14,29-15v2c6.48,10,3.32,40.74,18,41,9-6.08,24.52-4.92,36-8,22.6-6,49-7.41,73-13l27-2c11.91-2.61,27.72-1.25,40-4h23c13.69-2.92,48.34-3,62,0h23l59,5,55,8c45.2,11.67,90.76,17.7,132,33,23.67,8.79,48,16,71,26,12.7,5.5,30.29,17.48,45,19,4.58-4.45,12-5.91,18-9,10.58-5.49,21.5-15.73,35-17,3.41,3.21,9.66,4.88,15,6v1c-4.37,4.74-20.82,35.91-22,43,83.09,50.4,153.38,99.37,220,166,17.65,17.66,37.92,35,53,55,19.26,25.55,40.55,49.71,59,76,17,24.16,30.2,49.41,46,75,3.92,6.35,18.82,23.9,26,26h20c15,3.46,40.16,10.78,42,26-12.57,2.89-21.65,12.36-32,17-6.53,2.93-12.55,1.78-13,11,4.81,6.56,5.67,17.36,9,25,9.58,22,17.08,44.93,26,69,11.75,31.7,19.41,67.38,29,102,4.92,17.78,5.85,36.54,10,54l8,67v13c4.37,20.28,3,45.09,3,68v33l-4,63c-2.4,11-1.31,23.22-4,35-3.85,16.87-5,32-5,51,8.45,5.65,12.92,16.85,20,24,1.93,2,11.19,8.44,12,10v18c-2.39,4.29,2.13,12,3,17-10.1-.67-43-12.06-48-10-8.29,4.84-12.88,37.77-17,49-16.17,44.16-31.81,86.76-50,128-8.55,19.4-20.2,39.31-31,57-17.11,28-31.53,55.66-50,82-37.26,53.15-80.75,100.77-126,146a475.65,475.65,0,0,1-51,44c-9.61,7.21-18.2,16.94-28,24-7.59,5.48-29.82,17-31,27,3.35,3.38,5.75,11.64,3,18-2.25,5.21-7.61,10.47-10,16-1.82,4.21-.63,10.75-3,15l-10,10-1-1c-7.54-6.21-13.52-28.3-24-29-2.93,2.59-16.64,10.94-20,12-2-.33-3.8,1.68-5.8,1.35a41.29,41.29,0,0,0-6.2,2.65c-6,3.72-12.39,6.57-18,10-20.34,12.45-42.59,21.17-65,31-22.72,10-47.32,20.19-71,30-33,13.67-69.63,20.78-105,31-29.9,8.65-62,9.46-93,17l-69.48,6.49c-7.66,0-20.9-.31-28.52.51-13.54,1.46-49.26.83-62,0" style="fill-rule:evenodd"/>
                    </clipPath>
                </defs>
                <image clip-path="url(#clip_plate_zoom)" xlink:href="/assets/img/stars-map/plate-zoom.jpg" width="2168" height="2168" />
              </svg>
          </div>
        </div>
      </div>
    </div>
    <div id="string-interactive">
      <div class="string__handle scale-item">
        <span class="sicon sicon__string-handle" aria-hidden="true"></span>
        <span class="visuallyhidden">Slide Handle</span>
      </div>
      <div class="string-canvas-wrap active"><canvas id="string-canvas"  /></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'zoomStarsMapComponent',
    data() {
      return {
        stringHide: true,
        windowWidth: window.innerWidth,
        windowHeight:window.innerHeight,
        plateWidthLive:'',
        workPosLive:'',
        ropeHandle:'',
        sim:'',
        old:'',
        canvas:'',
        ctx:'',
        canvasW:0,
        canvasH:0,
        rtime:'',
        resizeTimeout: false,
        resizeDelay: 200,
        workEl:'',
        rotateEl:'',
        propellerInstanz:'',
        lastWindowW:'',
        lastWindowH:'',
        initRopeTimer: null,
        mouse: {x:0, y: 0},
      }
    },
    beforeRouteLeave (to, from, next) {
      document.body.classList.remove('zoomed-opened');
      document.body.style.height = '';
      document.querySelector('.zoom-stars-map').style.height = '';
      localStorage.setItem('starMap', 'zoom')
      next();
    },
    methods:{
      // Thus function returns if point is outside circle
      outsideCircle: function( centerX, centerY, radius, currentX, currentY) {
        var r = false;
        let val = Math.pow((currentX - centerX), 2) + Math.pow((currentY - centerY), 2);

        // Outside circle
        if (val > Math.pow(radius, 2)) {
          r = true;
        }

        return r;
      },
      getPlateWidth: function() {
        var ratio = 250 / 400;
        var getWindowWidth =  document.documentElement.clientWidth || document.body.clientWidth;

        var maxAailW = getWindowWidth * 0.85;

        this.plateWidthLive = maxAailW;

        this.workPosLive = maxAailW * (1 - ratio);

        if(this.plateWidthLive < window.innerHeight){
          this.workPosLive = (window.innerHeight - this.plateWidthLive) / 2;
        }

        if(window.innerWidth < window.innerHeight && window.innerWidth > 767 && window.innerWidth < 1025){
          this.workPosLive = ((window.innerHeight - this.plateWidthLive) / 2) + (window.innerHeight * 0.066);
        }

        var originalSize = document.querySelector('#rotator image').getAttribute('width');
        var getRatioToOriginal =    this.plateWidthLive / originalSize;
        var setMarginTop = 42;
        var setMarginLeft = -6;

        if(this.isIpadOS() || document.querySelector('html').classList.contains('isIOS')){
          if(window.innerWidth < 600){
            setMarginTop = 10;
          } else {
            setMarginTop = 18;
          }
        }

        document.querySelector('.plate-bg').style.marginTop = setMarginTop * getRatioToOriginal + 'px';
        document.querySelector('#rotator').style.marginLeft = setMarginLeft * getRatioToOriginal + 'px';

        document.getElementById('rotator').style.transform = 'translate3d(-50%,0,0) rotate(' + localStorage.getItem('starMap-plate')  + 'deg)';

        setTimeout(function (){
          if(document.querySelector('.zoomed-img-wrap').offsetHeight < window.innerHeight && window.innerWidth > 767){
            document.querySelector('.zoomed-img-wrap').style.height = window.innerHeight + 'px';
          } else {
            document.querySelector('.zoomed-img-wrap').style.height = '';
          }
        },10);
      },
      createRope: function () {
        this.sim =  new this.Sim()
        this.old = new Date().getTime()
        this.canvas = this.$el.querySelector('#string-canvas')
        this.ctx = this.canvas.getContext('2d')
        this.canvasW = this.canvas.width = this.windowWidth
        this.canvasH = this.canvas.height = document.querySelector('.zoomed-img-wrap').offsetHeight;

        if(window.innerWidth < 1010){
          this.canvasH = this.canvas.height = document.querySelector('body').offsetHeight;
        }
      },
      initRope: function () {
        this.createRope();
        var ropeHandleCenter = this.ropeHandle.offsetWidth / 2;

        var sim = this.sim

        var plateRect = this.$el.querySelector('.plate-wrap').getBoundingClientRect(),
          plateBottom = plateRect.height + plateRect.top,
          plateCenterX = plateRect.left + plateRect.width / 2,
          plateCenterY = this.workPosLive + (this.plateWidthLive / 2),
          ropeLength = Math.round((plateRect.width / 2 - this.ropeHandle.offsetWidth ) / 10 ) * 10,
          radius = (this.plateWidthLive * 0.9851) / 2;

        var gapSide = (window.innerWidth - this.plateWidthLive) / 2 - ropeHandleCenter;

        if(window.innerWidth < 900){
          //gapSide = 20;

          if(window.innerWidth < 499){
            //gapSide = 10;
          }
        }

        if(parseInt(localStorage.getItem('starMap-string-left')) <= window.innerWidth / 2){
          var sideB = plateCenterX - gapSide;
          var posX = gapSide;
        } else {
          sideB = window.innerWidth - gapSide - this.ropeHandle.offsetWidth - plateCenterX;
          posX = window.innerWidth - gapSide - this.ropeHandle.offsetWidth;
        }

        var sideA = sideB * parseFloat(localStorage.getItem('starMap-tangent'));


        if(parseInt(localStorage.getItem('starMap-string-top')) <= parseInt(localStorage.getItem('starMap-center-y'))){
          var posY = plateCenterY - sideA - ropeHandleCenter;
        } else {
          posY = plateCenterY + sideA - ropeHandleCenter;
        }

        if(this.outsideCircle(plateCenterX, plateCenterY, radius, posX, posY)){
          var posAlphaY = plateCenterY - posY;
          var posAlphaX =  plateCenterX - posX;

          let alpha = (Math.atan2(posAlphaY, posAlphaX * -1) * 180 / Math.PI + 360) % 360;

          var maxX = Math.abs(radius * Math.cos(alpha / 180 * Math.PI));
          var maxY = Math.abs(radius * Math.sin(alpha / 180 * Math.PI));

          var newPosX = Math.min(Math.max(-maxX, posAlphaX), maxX)
          var newPosY = Math.min(Math.max(-maxY, posAlphaY), maxY)

          posX = -newPosX + plateCenterX;
          posY = -newPosY + plateCenterY;
        }

        // step = distance between dots
        // length = rope length
        var op,
          mouse,
          anchor,
          step = 10,
          length = ropeLength > 100 ? 80 : ropeLength;

        if(window.innerWidth < 768){
          length = 40;
        }

        var count = length / step;

        for (var i = 0; i < count; ++i) {

          //rope dots starting point -> start form center of window width, bottom of plate position
          var np = new this.Particle(window.innerWidth / 2, plateBottom,  10.1);

          sim.particles.push(np);

          if (i > 0) sim.springs.push(new this.Spring(np, op, step,1.5));

          op = np;
        }

        // Fix the first particle
        anchor = sim.particles[0];
        anchor.fixed = true;
        anchor.x = plateCenterX;
        anchor.y = plateCenterY;

        this.ropeHandle.style.left = posX + 'px';
        this.ropeHandle.style.top = posY + 'px';

        // Move last particle with mouse
        mouse = sim.particles[count - 1];
        mouse.fixed = true;
        mouse.x = posX + ropeHandleCenter;
        mouse.y = posY + ropeHandleCenter;

        this.mouse = mouse;

        var self = this;
        var countTime = 0;
        var initInterval = setInterval(function(){
          ++countTime;
          self.ropeStep()
          if(countTime == 20){
            clearInterval(initInterval);
            self.isLoaded = true
          }
        }, 1);
      },
      ropeStep: function () {
        var old = this.old
        var now = new Date().getTime(),
          delta = now - old;
        var sim = this.sim
        var ctx = this.ctx

        sim.tick(delta);

        // Draw
        ctx.clearRect(0, 0, this.canvasW, this.canvasH);

        var p = sim.particles.length;
        while (p--) {
          var particle = sim.particles[p];
          ctx.beginPath();
          ctx.fillStyle = "transparent";
          ctx.fillRect(particle.x, particle.y, 1, 1)
        }

        var s = sim.springs.length;
        while (s--) {
          var spring = sim.springs[s];
          ctx.beginPath();
          ctx.moveTo(spring.p1.x, spring.p1.y);
          ctx.lineTo(spring.p2.x, spring.p2.y);
          ctx.strokeStyle = 'white';
          ctx.lineWidth = 2;
          ctx.shadowColor = '#666';
          ctx.shadowBlur = 4;
          ctx.lineJoin = 'bevel';
          ctx.stroke();
        }
        old = now;
      },
      resizeRope: function () {
        if (new Date() - this.rtime < this.resizeDelay) {
          setTimeout(this.resizeRope, this.resizeDelay);
        } else {
          this.resizeTimeout = false;
          this.initRope();
        }
      },
      checkHeightOnMobile: function (){
        if(window.innerWidth < 768){
          var winH = window.innerHeight;
          document.body.style.height = winH + 'px';
          document.querySelector('.zoom-stars-map').style.height = winH + 'px';

          if(document.querySelector('.plates-wrap').clientHeight + this.workPosLive < winH){
            document.body.classList.add('zoomed-overflow');
          }
        }
      }
    },
    mounted() {
      var _this = this;
      this.ropeHandle = this.$el.querySelector('.string__handle');
      document.body.classList.add('zoomed-opened');
      this.getPlateWidth();
      this.initRopeTimer = setTimeout(_this.initRope, 500);

      this.checkHeightOnMobile();

      window.onorientationchange = () => {
        if(localStorage.getItem('orientationchange')){
          localStorage.removeItem('orientationchange');
        } else {
          localStorage.setItem('starMap-orientationchange', true);
        }
      }

      window.onresize = () => {
        this.windowHeight = window.innerHeight
        this.windowWidth = window.innerWidth

        this.checkHeightOnMobile();

        this.getPlateWidth();
        this.rtime = new Date();
        if (this.resizeTimeout === false) {
          this.resizeTimeout = true;
          this.isLoaded = false
          setTimeout(this.resizeRope, this.resizeDelay);
        }
        this.lastWindowW = window.innerWidth
        this.lastWindowH = window.innerHeight
      }

    }
  }
</script>
